module.exports = __webpack_public_path__ + "public/files/img/banner.5a8a55c6.png";